import React, { useContext, useEffect } from 'react';
import { Input, TextArea } from '@m/alchemy-ui';
import { getNestedProperty } from '@mdigital/common/dist/utils/object';
import { getSingleText } from '../../../../../../../../common/utils';
import { TriggerContext } from '../../../../../index';
import { PanelSubHeader } from '../../../../../StyledTriggeringModal';
import TargetingField from '../../../../Shared/TargetingField';
import { TargetingActions } from '../../../Actions';
import { TextPathPrefix } from '../../../index';
import {
  StyledContentContainer,
  StyledSubTitle,
  StyledTargetingSettingsContainer
} from '../../../StyledTriggerByTargeting';

export const LocalNotificationBasicFields = () => {
  const { triggerState , triggerDispatch, isReadOnly } = useContext(TriggerContext);
  const [inputCounter, setInputCounter] = React.useState(0);

  useEffect(() => {
    const title = getNestedProperty(triggerState, 'trigger.triggerCustomLocalNotificationContract.title', '');
    setInputCounter(title ? title.length : 0);
  }, [triggerState]);

  const titleMaxLength = 30;
  return (
    <StyledTargetingSettingsContainer>
      <StyledContentContainer>
        <StyledSubTitle>
          <PanelSubHeader>{getSingleText(`${TextPathPrefix}.content`)}</PanelSubHeader>
        </StyledSubTitle>
        <TargetingField
          required={true}
          className="custom-field-margin"
          label="Title Text"
          errorMessage="Title is required"
          inputMaxLength={titleMaxLength}
          inputCounter={inputCounter}
          disabled={isReadOnly}
          render={<Input
            maxLength={titleMaxLength}
            value={getNestedProperty(triggerState, 'trigger.triggerCustomLocalNotificationContract.title') || ''}
            placeholder={getSingleText(`${TextPathPrefix}.titlePlaceholder`)}
            onChange={ (e) => triggerDispatch({ type: TargetingActions.SET_TITLE_TEXT , payload : e.target.value })} />}
        />
        <TargetingField
          required={true}
          label="Description Text"
          errorMessage="Description is required"
          disabled={isReadOnly}
          render={<TextArea
            maxLength={70}
            value={getNestedProperty(triggerState, 'trigger.triggerCustomLocalNotificationContract.body') || ''}
            placeholder={getSingleText(`${TextPathPrefix}.descriptionPlaceholder`)}
            onChange={ (e) => triggerDispatch({ type: TargetingActions.SET_DESCRIPTION_TEXT , payload : e.target.value })} />}
        />
      </StyledContentContainer>

    </StyledTargetingSettingsContainer>
  );
};
